export { default } from './SectionCard';
export type { SectionCardProps } from './SectionCard.types';
